import React from "react";
import { Alert, useErrorContext } from "tds_shared_ui";

export function ErrorAlert() {
  const { clearError, alert, alertRef } = useErrorContext();

  if (!alert?.display) {
    return null;
  }

  return (
    <Alert
      ref={alertRef}
      type={alert.type || "error"}
      dismissible
      onDismiss={clearError}
    >
      {alert.message}
    </Alert>
  );
}
